import { supabase } from '../supabaseClient'

/** Config normalizada usada no Kanban (fonte: Supabase por empresa). */
export function normalizeKanbanConfig(row) {
  return {
    customColunas: Array.isArray(row?.colunas_custom) ? row.colunas_custom : [],
    ocultas: Array.isArray(row?.colunas_ocultas) ? row.colunas_ocultas : []
  }
}

const CONFIG_VAZIA = { customColunas: [], ocultas: [] }

/**
 * Carrega config do Kanban no Supabase — mesma visão para todos da empresa.
 * Não usa localStorage como fonte (evita um usuário ver 3 colunas e outro ver 2).
 */
export async function loadKanbanConfigRemoto(empresaId) {
  const id = empresaId?.id || empresaId
  if (!id) return CONFIG_VAZIA

  const { data, error } = await supabase
    .from('leads_kanban_config')
    .select('colunas_custom, colunas_ocultas')
    .eq('empresa_id', id)
    .maybeSingle()

  if (error) {
    console.error('[Leads Kanban] Erro ao carregar config:', error.message)
    return CONFIG_VAZIA
  }

  if (!data) return CONFIG_VAZIA
  return normalizeKanbanConfig(data)
}

/**
 * Salva no Supabase — todos os usuários da empresa passam a ver as mesmas colunas.
 */
export async function saveKanbanConfigRemoto(empresaId, config) {
  const id = empresaId?.id || empresaId
  const payload = {
    customColunas: config.customColunas || [],
    ocultas: config.ocultas || []
  }

  if (!id) return { ok: false, error: 'Empresa não identificada' }

  const { error } = await supabase.from('leads_kanban_config').upsert(
    {
      empresa_id: id,
      colunas_custom: payload.customColunas,
      colunas_ocultas: payload.ocultas,
      updated_at: new Date().toISOString()
    },
    { onConflict: 'empresa_id' }
  )

  if (error) {
    console.error('[Leads Kanban] Erro ao salvar config:', error)
    return { ok: false, error: error.message }
  }
  return { ok: true, config: payload }
}
